class GiftBagHandler {
  constructor() {
    this._boundHandleChange = this._handleChange.bind(this);
    document.addEventListener('change', this._boundHandleChange);
    GiftBagHandler.bindLabels();
  }

  _handleChange(event) {
    const checkbox = event.target.closest('[data-gift-bag-checkbox]');
    if (!checkbox) return;
    this._toggle(checkbox);
  }

  async _toggle(checkbox) {
    const variantId = checkbox.dataset.variantId;
    const isChecked = checkbox.checked;

    checkbox.disabled = true;

    try {
      if (isChecked) {
        await this._addGiftBag(variantId);
      } else {
        await this._removeGiftBag(variantId);
      }
    } catch (error) {
      console.error('Gift bag error:', error);
      checkbox.checked = !isChecked;
    } finally {
      checkbox.disabled = false;
    }
  }

  async _addGiftBag(variantId) {
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    const response = await fetch(window.routes.cart_add_url, config);
    const data = await response.json();

    if (data.status) {
      throw new Error(data.description);
    }

    await this._updateCart();
  }

  async _removeGiftBag(variantId) {
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    const giftBagItemIndex = cart.items.findIndex(
      item => String(item.variant_id) === String(variantId)
    );

    if (giftBagItemIndex === -1) return;

    const body = JSON.stringify({
      line: giftBagItemIndex + 1,
      quantity: 0
    });

    const response = await fetch(window.routes.cart_change_url, {
      ...fetchConfig(),
      body
    });

    if (!response.ok) {
      throw new Error('Failed to remove gift bag');
    }

    await this._updateCart();
  }

  async _updateCart() {
    const cartDrawer = document.querySelector('cart-drawer');
    const cartItems = document.querySelector('cart-items');

    const sections = ['cart-drawer', 'cart-counter'];
    const mainCartEl = document.getElementById('main-cart-items');
    if (mainCartEl && mainCartEl.dataset.id) {
      sections.push(mainCartEl.dataset.id);
    }

    const sectionsResponse = await fetch(
      `${window.location.pathname}?sections=${sections.join(',')}`
    );
    const sectionsData = await sectionsResponse.json();

    if (cartDrawer) {
      cartDrawer.renderContents({ sections: sectionsData }, false);
    }

    if (cartItems && mainCartEl && mainCartEl.dataset.id) {
      const sectionId = mainCartEl.dataset.id;
      const sectionHtml = sectionsData[sectionId];
      if (sectionHtml) {
        const selector = `#shopify-section-${sectionId} cart-items`;
        const el = document.querySelector(selector);
        if (el) {
          el.innerHTML = new DOMParser()
            .parseFromString(sectionHtml, 'text/html')
            .querySelector(selector).innerHTML;
        }
      }
      if (typeof updateFreeShipping === 'function') {
        updateFreeShipping();
      }
    }

    // Re-bind labels for any newly rendered checkboxes
    GiftBagHandler.bindLabels();
  }

  static bindLabels() {
    document.querySelectorAll('[data-gift-bag-checkbox]').forEach(checkbox => {
      const label = checkbox.nextElementSibling;
      if (label && label.tagName === 'LABEL' && !label.dataset.giftBagBound) {
        label.dataset.giftBagBound = '1';
        label.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          checkbox.click();
        });
      }
    });
  }
}

// Initialize once – event delegation handles all current and future checkboxes
function initGiftBagHandler() {
  if (!initGiftBagHandler._instance) {
    initGiftBagHandler._instance = new GiftBagHandler();
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initGiftBagHandler);
} else {
  initGiftBagHandler();
}
